export default __webpack_public_path__ + "static/badge_aws_cloud_practitioner-f047237ef130ce4f2d94fcbda013e060.png";